import React from 'react';
import { StyledH1, StyledH2 } from './Heading.styled';

type Variant = 'h1' | 'h2';

type Props = {
  variant: Variant;
};

const Heading: React.FC<Props> = ({ variant = 'h1', children }) => {
  return variant === 'h1' ? <StyledH1>{children}</StyledH1> : variant === 'h2' ? <StyledH2>{children}</StyledH2> : null;
};

export default Heading;
